import React from 'react';

import PropTypes from 'prop-types';

import ArrowGreen from '@/assets/icons/ArrowGreen.svg';
import ArrowRed from '@/assets/icons/ArrowRed.svg';

import { CardContainer, MetricTitle, MetricValueWrapper, MetricValue, MetricGoal, PercentageContainer, PercentageText } from './styles';

const MetricCard = ({ title, value, unit, goal, percentage, isAboveGoal }) => {
    const formatPercentage = (percent) => {
        if (percent === null || percent === undefined) return null;
        const absPercent = Math.abs(percent);
        return absPercent.toFixed(1).replace('.', ',');
    };

    return (
        <CardContainer>
            <MetricTitle>{title}</MetricTitle>
            <MetricValueWrapper>
                <MetricValue>
                    {value}
                    {unit && <span>{unit}</span>}
                </MetricValue>
                {percentage !== null && isAboveGoal !== null && (
                    <PercentageContainer>
                        <img src={isAboveGoal ? ArrowGreen : ArrowRed} alt={isAboveGoal ? 'Acima da meta' : 'Abaixo da meta'} />
                        {/*<PercentageText isAboveGoal={isAboveGoal}>{formatPercentage(percentage)}%</PercentageText> */}
                    </PercentageContainer>
                )}
            </MetricValueWrapper>
            {goal !== null && goal !== undefined ? <MetricGoal>Meta: {goal}</MetricGoal> : <MetricGoal>Meta:</MetricGoal>}
        </CardContainer>
    );
};

MetricCard.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    unit: PropTypes.string,
    goal: PropTypes.string,
    percentage: PropTypes.number,
    isAboveGoal: PropTypes.bool
};

export default MetricCard;
